import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        countries: string[]
      }
    }
  }
}

export default function countries(): Promise<string[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { countries },
        },
      },
    }: Payload) => countries
  )
}

const query = gql`
  query countries {
    viewer {
      company {
        countries
      }
    }
  }
`
